<template>
  <label>
    <span v-if="$slots.label"><slot name="label"></slot></span>
    <br v-if="labelbr" />
    <textarea
      :name="name"
      :style="styles"
      :placeholder="placeholderValue"
      :value="value"
      @input="updateValue"
      :rows="rows"
      :wrap="wrap"
      :maxlength="maxlength"
      :cols="cols"
      :readonly="readonly"
      :labelbr="labelbr"
    />
  </label>
</template>

<script>
export default {
  props: {
    name: {},
    label: {},
    value: {},
    color: {},
    width: {},
    readonly: {},
    placeholderValue: {},
    rows: {},
    wrap: {},
    maxlength: {},
    cols: {},
    labelbr: null
  },
  methods: {
    updateValue(e) {
      e.target.value = e.target.value.replace(/\r?\n/g, '')
      this.$emit('input', e.target.value);
      this.$emit('change', e.target.value);
    }
  },
  computed: {
    // バインドするスタイルを生成
    styles() {
      return {
        '--color': this.color,
        '--width': this.width
      };
    }
  }
};
</script>

<style lang="stylus" scoped>
textarea // Firefoxでのフォーカスは効かない
  border:0;
  padding:10px;
  font-size:1em;
  border:solid 1px #ccc !important;
  margin: 0 0 20px;
  -webkit-box-shadow: 0px 1px rgba(255, 255, 255, 0.5);
  -moz-box-shadow: 0px 1px rgba(255, 255, 255, 0.5);
  box-shadow: 0px 1px rgba(255, 255, 255, 0.5);
  -webkit-border-radius: 4px !important;
  -moz-border-radius: 4px !important;
  border-radius: 4px !important;
  -moz-box-shadow: inset 0 0 4px rgba(0,0,0,0.2);
  -webkit-box-shadow: ins t 0 0 4px rgba(0, 0, 0, 0.2);
  box-shadow: inner 0 0 4px rgba(0, 0, 0, 0.2);
  --color: white
  --width: 100%
  background-color: var(--color);
  width: var(--width);
</style>
